// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2J7Gb","amount":"Amount_amount__4NaWL","tip":"Amount_tip__iqjvo","tipHeader":"Amount_tipHeader__CCFGe","tipsWrap":"Amount_tipsWrap__3YllB"};